// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.apexcharts-legend-marker,\n.apexcharts-legend-text {\n  float: left;\n  display: inline-block;\n  line-height: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
